import React from "react";
export function CollaborationFollowUp({value}) {
  if(!value)return null;
  return <div className="space-y-2 rounded-xl border border-border p-3 text-sm" aria-label="Yhteistyön jatko">
    <p>Vastauksia {value.answered} / {value.total}</p>
    <p className="text-xs text-muted-foreground">{value.reason==="expired"?"Vastausaika päättyi":"Vastausaika päättyy"} <time dateTime={value.expires_at}>{new Date(value.expires_at).toLocaleString("fi-FI",{timeZone:"Europe/Helsinki",dateStyle:"short",timeStyle:"short"})}</time></p>
    <p>{value.next_step}</p>
  </div>;
}
